export const EPISODE_ORDERINGS = {
  REVERSE_CHRONOLOGICAL: 'reverse_chronological',
  NORMAL: 'normal',
} as const

export const getEpisodeOrdering = (slug: string) => {
  if (slug === 'goat') {
    return EPISODE_ORDERINGS.REVERSE_CHRONOLOGICAL
  }
  return EPISODE_ORDERINGS.NORMAL
}

export type EpisodeOrdering =
  (typeof EPISODE_ORDERINGS)[keyof typeof EPISODE_ORDERINGS]
